import {keyBy} from 'lodash-es';
import {gettext} from '../../../../../../utility/gettext.util.service';

class Options {
  constructor() {
    this._priorityOptions = [
      {
        value: 'Low',
        label: gettext('Low')
      },
      {
        value: 'Medium',
        label: gettext('Medium')
      },
      {
        value: 'High',
        label: gettext('High')
      }
    ];

    this._relationalSymbolsOptions = [
      {
        value: '<',
        label: '<',
        description: gettext('Less Than')
      },
      {
        value: '<=',
        label: '<=',
        description: gettext('Less Than or Equal to')
      },
      {
        value: '>',
        label: '>',
        description: gettext('Greater Than')
      },
      {
        value: '>=',
        label: '>=',
        description: gettext('Greater Than or equal to')
      },
      {
        value: '==',
        label: '=',
        description: gettext('Equal to'),
        stateRelational: true
      },
      {
        value: '!=',
        label: '!=',
        description: gettext('Not Equal to'),
        stateRelational: true
      }
    ];

    this._unitOfTimeOptions = [
      {
        value: 'seconds',
        label: gettext('Second(s)')
      },
      {
        value: 'minutes',
        label: gettext('Minute(s)')
      },
      {
        value: 'hours',
        label: gettext('Hour(s)')
      }
    ];
    this._clearOptions = [
      {
        value: 'Immediately',
        label: gettext('Immediately')
      },
      {
        value: 'OneDay',
        label: gettext('After 24hrs')
      }
    ];
    this._notifyOnReturnOptions = [
      {
        value: true,
        label: gettext('Yes')
      },
      {
        value: false,
        label: gettext('No')
      }
    ];
  }
  get priorityOptions() {
    return this._priorityOptions;
  }
  get relationalSymbolsOptions() {
    return this._relationalSymbolsOptions;
  }
  get unitOfTimeOptions() {
    return this._unitOfTimeOptions;
  }
  get clearOptions() {
    return this._clearOptions;
  }
  get notifyOnReturnOptions() {
    return this._notifyOnReturnOptions;
  }
  get indexedPriorityOptions() {
    return keyBy(this._priorityOptions, 'value');
  }
  get indexedRelationalSymbolsOptions() {
    return keyBy(this._relationalSymbolsOptions, 'value');
  }
  get indexedUnitOfTimeOptions() {
    return keyBy(this._unitOfTimeOptions, 'value');
  }
  get indexedClearOptions() {
    return keyBy(this._clearOptions, 'value');
  }
  get indexedNotifyOnReturnOptions() {
    return keyBy(this._notifyOnReturnOptions, 'value');
  }
}

export const options = new Options();

export class TriggerView {
  constructor(id) {
    this.id = id;
    this.dataPoint = '';
    this.condition = {
      relationalOperator: '',
      thresholdValue: '',
      duration: '',
      unitOfTime: ''
    };
    this.priority = '';
    this.autoClear = '';
    this.notifyOnReturn = '';
    this.valuesDescriptors = undefined;
  }
}

export class ApiTrigger {
  constructor(triggerView = {}) {
    this.id = triggerView.id;
    const {dataPoint = {}} = triggerView || {};
    this.dataPoint = dataPoint.id;
    this.priority = triggerView.priority;
    this.autoClear = triggerView.autoClear;
    this.notifyOnReturn = triggerView.notifyOnReturn;
    const {relationalOperator, thresholdValue, duration, unitOfTime} = triggerView.condition || {};
    this.condition = `IF [value] ${relationalOperator} ${thresholdValue} FOR ${duration} ${unitOfTime}`;
  }
}
